import React from 'react'
import FormField, { FormFieldProps } from './FormField'
import { TimePicker, Typography, useColorMode } from '@airbus/components-react/components'
import { TimePickerProps } from '@airbus/components-react/components/TimePicker'
import FormControl from './FormControl'
import { FormControlProps } from '@airbus/components-react/components/Form'
import DurationPicker from './DurationPicker'
import { FieldError, FieldErrors } from 'react-hook-form'
import i18n from 'i18n'

type CustomDurationPickerProps = TimePickerProps & FormControlProps
export const CustomDurationPicker = ({
  inputRef,
  label,
  error,
  readOnly = false,
  value,
  pattern,
  onChange,
  labelAdornment,
  required = false,
  style,
  ...rest
}: CustomDurationPickerProps) => {
  const theme = useColorMode()

  return (
    <FormControl
      label={label}
      error={error}
      labelAdornment={labelAdornment}
      readOnly={readOnly}
      required={required}
      style={style}
    >
      {readOnly ? (
        <Typography
          style={{
            fontWeight: 'bold',
            lineHeight: theme.size.spacing[40],
            overflowX: 'auto',
          }}
        >
          {value || '-'}
        </Typography>
      ) : (
        // TODO EHA changer partout pour que ça stocke HH:mm dans RHF
        <DurationPicker
          pattern={pattern}
          value={value || ' '}
          onChange={onChange}
          {...rest}
          inputProps={{ tabIndex: 0 }}
        />
      )}
    </FormControl>
  )
}

export const FormDuration = (props: FormFieldProps<CustomDurationPickerProps>) => (
  <FormField {...props} Component={CustomDurationPicker} />
)

const manageFormError = (error: FieldError, messageHandler: (s: string, t: string) => void) => {
  if (error?.type) {
    if (error?.type === 'required') {
      messageHandler('warning', i18n.t('input_compulsory_fields_missing'))
    } else if (error) {
      messageHandler('warning', i18n.t('input_fields_in_error'))
    }
    return
  } else if (Object.values(error)[0]?.type) {
    manageFormError(Object.values(error)[0], messageHandler)
  }
}

const manageFormErrors = (errors: FieldErrors, messageHandler: (s: string, t: string) => void) => {
  Object.values(errors).forEach((error) => error && manageFormError(error, messageHandler))
}

export { manageFormErrors }

export default FormDuration
